export default "<span class=\"new-tag\" translate>NEW</span>\n";